/**
 * Ce qu'on peut lancer depuis un client — chunk 9.BF.1.
 *
 * ## La frontière, et pourquoi elle tient
 *
 * **L'entreprise oriente. Le dossier exécute.** Les gestes qui vivent ici
 * *créent* ou *mènent quelque part* ; ceux qui font avancer une demande précise
 * — envoyer, relancer, rattacher un cahier de charges, comparer — restent au
 * dossier, où se trouve le contexte qui les rend sûrs.
 *
 * Les remonter ici dupliquerait la page projet, et donnerait deux endroits pour
 * un même geste engageant. Un envoi déclenché depuis une fiche client, sans voir
 * ce qui part ni à qui, est exactement ce que 9.AZ.1 avait corrigé.
 *
 * ## Aucune logique nouvelle
 *
 * Chaque action est un lien vers un parcours qui existe. « Nouvelle demande »
 * réutilise `/requests/new` avec le client prérempli : le dossier se crée, puis la demande
 * s'enchaîne — la fiche client n'a rien à orchestrer.
 */

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function CompanyActions({ companyId }: { readonly companyId: string }) {
  const { t } = useTranslation();

  return (
    <nav aria-label={t("company_hub.actions.label")} className="flex flex-wrap gap-2">
      <Link
        to={`/requests/new?company_id=${companyId}`}
        className="bg-brand-600 hover:bg-brand-700 focus-visible:ring-brand-500 inline-flex min-h-11 touch-manipulation items-center rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      >
        {t("company_hub.actions.new_request")}
      </Link>
      <Link
        to={`/companies/${companyId}#contacts`}
        className="focus-visible:ring-brand-500 inline-flex min-h-11 touch-manipulation items-center rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      >
        {t("company_hub.actions.add_contact")}
      </Link>
    </nav>
  );
}
